var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-preview" }, [
    _c("div", { attrs: { id: "contents" } }, [
      _c("div", { staticClass: "inner clearfix detail-top" }, [
        _vm.interview.companyName
          ? _c(
              "p",
              {
                staticClass: "mt10 fll hd-type-01 company-name",
                attrs: { "data-test": "company-name" },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.interview.companyName) + "\n      "
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "clearfix" }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm.interview.catchCopy
          ? _c("div", { staticClass: "company-area" }, [
              _c(
                "h1",
                {
                  staticClass: "fs16 hd-type-02 company-title option-title",
                  attrs: { "data-test": "catch-copy" },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.interview.catchCopy) +
                      "\n        "
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "contents-inner clearfix mb30" }, [
          _c("section", [
            _c("article", [
              _vm.interview.image ||
              _vm.interview.intervieweePosition ||
              _vm.interview.intervieweeName ||
              _vm.interview.intervieweeProfile
                ? _c(
                    "div",
                    {
                      staticClass: "clearfix mb25 pb10",
                      attrs: {
                        "data-test": "main-image-with-interviewee-area",
                      },
                    },
                    [
                      _vm.interview.image
                        ? _c(
                            "figure",
                            {
                              staticClass: "flr ml30 interview-top-img",
                              attrs: { "data-test": "photo-main" },
                            },
                            [
                              _c("img", {
                                staticClass: "flr ml30 interview-img-main",
                                attrs: {
                                  src: _vm.getPhotoUrl(_vm.interview.image),
                                  "data-test": "photo-main-img",
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.interview.intervieweePosition ||
                      _vm.interview.intervieweeName ||
                      _vm.interview.intervieweeProfile
                        ? _c(
                            "div",
                            {
                              staticClass: "tl profile fs13",
                              attrs: { "data-test": "interviewee-area" },
                            },
                            [
                              _vm.interview.intervieweePosition
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "fwB",
                                      attrs: { "data-test": "position" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.interview.intervieweePosition
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.interview.intervieweeName
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "fwB fs15",
                                      attrs: {
                                        "data-test": "interviewee-name",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.interview.intervieweeName
                                          ) +
                                          "さん\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.interview.intervieweePosition ||
                              _vm.interview.intervieweeName
                                ? _c("br")
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.interview.intervieweeProfile
                                ? _c("p", {
                                    staticClass:
                                      "pega-pre-wrap interviewee-profile",
                                    attrs: { "data-test": "profile" },
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.interview.intervieweeProfile
                                      ),
                                    },
                                  })
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "details clearfix" },
                [
                  _vm._l(_vm.interview.contentList, function (content, i) {
                    return [
                      _c(
                        "div",
                        {
                          key: i,
                          staticClass:
                            "border_red interview-block pt30 pb30 plr20 clearfix",
                          style:
                            "background: url(" +
                            _vm.userImageUrlForPc +
                            "/option/interview/bg_stripe_gray.png) repeat top left;",
                          attrs: { "data-test": "content-" + i },
                        },
                        [
                          content.title
                            ? _c("p", {
                                staticClass: "mb15 fwB tc fs16 pega-pre-wrap",
                                attrs: { "data-test": "title-" + i },
                                domProps: {
                                  textContent: _vm._s(content.title),
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "message-inner" }, [
                            content.image || content.photoCaption
                              ? _c(
                                  "figure",
                                  {
                                    staticClass: "fll mr20 block-figure",
                                    attrs: {
                                      "data-test": "photo-caption-area-" + i,
                                    },
                                  },
                                  [
                                    content.image
                                      ? _c("img", {
                                          staticClass: "mb10 interview-img-sub",
                                          attrs: {
                                            src: _vm.getPhotoUrl(content.image),
                                            "data-test": "photo-" + i,
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    content.photoCaption
                                      ? _c("figcaption", {
                                          staticClass: "fs11 pega-pre-wrap",
                                          attrs: {
                                            "data-test": "caption-" + i,
                                          },
                                          domProps: {
                                            textContent: _vm._s(
                                              content.photoCaption
                                            ),
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            content.text
                              ? _c("p", {
                                  staticClass: "message p15 pega-pre-wrap",
                                  attrs: { "data-test": "text-" + i },
                                  domProps: {
                                    textContent: _vm._s(content.text),
                                  },
                                })
                              : _vm._e(),
                          ]),
                        ]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "mt30 fs13 detail-menu" }, [
      _c("a", [
        _c("li", { attrs: { "data-test": "tab-menu-job" } }, [
          _vm._v("募集情報"),
        ]),
      ]),
      _vm._v(" "),
      _c("a", [
        _c("li", { attrs: { "data-test": "tab-menu-photo-clip" } }, [
          _vm._v("フォトクリップ"),
        ]),
      ]),
      _vm._v(" "),
      _c("span", [
        _c(
          "li",
          {
            staticClass: "active",
            attrs: { "data-test": "tab-menu-interview" },
          },
          [_vm._v("インタビュー記事")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }